module.exports = __webpack_public_path__ + "aac776e0fa80b8f97237da5f58a1d563.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/img1_1.jpg
// module id = 286
// module chunks = 0